import { RESET_DELETE_CAT} from '../types'
export const resetdeletecat = () => {

    return (dispatch) => {
        dispatch({ type: RESET_DELETE_CAT });
    }
}